import React, { useState, useEffect } from "react";
import styles from "./BookSlotComponent.module.css";
import styless from "./BookingForm.module.css";
import { useDispatch, useSelector } from "react-redux";
import { updateBookingData } from "../slice/currentBookingSlice";
import PriceInfoContainer from "./PriceInfoContainer";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { DEV_API } from "../Common/Constant";
import { updateGdInfo } from "../slice/gdInfoSlice";
import { getCalendarStartDate } from "../Common/Common";

const BookingForm = () => {
  const { location:prevSelectedLocation, totalPlayers:prevSelectedPlayers, date:prevSelectedDate } = useSelector((state) => state.cBookingReducer);
  const { locations, fetchedGdInfo } = useSelector((state) => state.gdInfoSlice);
  const navigate = useNavigate();

  const startDate = getCalendarStartDate();

  const threeMonthsFromToday = new Date();
  const today = new Date();
  threeMonthsFromToday.setMonth(today.getMonth() + 3);
  const maxDateString = threeMonthsFromToday.toISOString().split("T")[0];

  const [location, setLocation] = useState("");
  const [date, setDate] = useState(startDate);
  const [players, setPlayers] = useState(1);
  const dispatch = useDispatch(); // Assuming you are using Redux for state management

  useEffect(() => {
    // Set the current date as the default value for the date field
    // Now hardcoded in reducer slice, thus api call will not happen
    if (!fetchedGdInfo) getGDInfo();
  }, []);

  useEffect(()=>{
    //remove this after removing hardcode in gdinfoSlice
    setLocation(locations && locations[0] && locations[0].loc_id || '');
  } ,[locations])

  useEffect(() => {
    if (prevSelectedLocation && prevSelectedPlayers && prevSelectedDate) {
      setLocation(prevSelectedLocation);
      setDate(prevSelectedDate);
      setPlayers(prevSelectedPlayers);
    }
  }, [prevSelectedLocation, prevSelectedPlayers, prevSelectedDate]);

  const getGDInfo = () => {
    const token = window.localStorage.getItem('token');
    axios
      .get(`${DEV_API}/getGDInfo`, {
        headers: {
          authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        dispatch(updateGdInfo({locations: response.data})); // Dispatch the booking data to Redux store
        setLocation(response?.data && response?.data[0] && response?.data[0].loc_id || ''); // Set the default location to the first one in the list
      })
      .catch((error) => {
        console.error("Error fetching GD info:", error);
      });
  };

  const handleGoClick = () => {
    dispatch(updateBookingData({ location, date, totalPlayers: players })); // Dispatch the booking data to Redux store
    navigate("/book-slot");
  };

  const onLocChange = (e) => {
    setLocation(e.target.value);
  };

  const decPlayers = () => {
    setPlayers((prev) => prev - 1);
  };

  const incPlayers = () => {
    setPlayers((prev) => prev + 1);
  };

  return (
    <div className={styles.bookingSlotFormContainer}>
      <div className={styles.bookingFormContainer}>
        <div className={styles.leftSection}>
          <h2 className="tleft">Choose Location</h2>
          <select
            className={`gdSelect fullWidth ${
              locations.length < 2 ? "hideDDArrow" : ""
            }`}
            disabled={locations.length < 2}
            onChange={onLocChange}
            value={location}
          >
            {(locations || []).map((loctn, i) => (
              <option key={`${"ind"}-${i}`} value={loctn.loc_id}>
                {loctn.name}
              </option>
            ))}
          </select>
        </div>
        <div className={styles.rightSection}>
          <div>
            <label htmlFor="date" className={styles.dateLabel}>
              <h2 className="tleft">Date</h2>
            </label>
            <input
              type="date"
              id="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              className={styles.dateInput}
              min={startDate}
              max={maxDateString}
            />
          </div>
          <div>
            <label htmlFor="players" className={styles.playersLabel}>
              <h2 className="tleft">Total No of Players</h2>
            </label>
            <div className={styless.playerCountDiv}>
            <button className={`headerButtons ${styless.btn}`} onClick={decPlayers}>-</button>
            <input
              type="number"
              id="players"
              value={players}
              onChange={(e) => setPlayers(e.target.value)}
              className={styles.playersInput}
              min="1"
              placeholder="Enter number of players"
            />
            <button className={`headerButtons ${styless.btn}`} onClick={incPlayers}>+</button>
            </div>
          </div>
        </div>
        <div className={styles.centerSection}>
          <button
            className={styles.goButton}
            onClick={handleGoClick}
            disabled={!location || !date || !players} // Enable only if all fields are filled
          >
            Go
          </button>
        </div>
      </div>
      <PriceInfoContainer players={players} />
    </div>
  );
};

export default BookingForm;
